// eslint-disable-next-line camelcase
import migrate_content from './migrate_content';
import { store } from '../../../Store';

export default function cmsStore(props) {
  const initialState = props;

  initialState.cms.content = migrate_content(initialState.cms.content);

  const noOpReducer = initial => (state = initial || null) => state;

  if (initialState.cms && (!store.getState().cms || store.getState().cms !== initialState.cms)) {
    store.injectReducer('cms', noOpReducer(initialState.cms));
  }

  if (initialState.location && !store.getState().location) {
    store.injectReducer('location', noOpReducer(initialState.location));
  }

  return store;
}
